function mapNetwork(network: string) {
  const networkMap = {
    "Mendel": "Stores",
    "UFF": "FCs",
    "Malone": "Stores",
    "SSD": "SSD",
    "QC": "QC"
  };
  return networkMap[network] ? networkMap[network] : "?"
};

export { mapNetwork };
